import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Pic } from "./Pic";
import { useT } from "@/i18n";

// "Prodotti in evidenza": overview of the main solutions with links, the current page is left out.
export const FEATURED = [
  ["/legno-lamellare", "nav.legno-lamellare", "Legno lamellare", "/img/emma/p-travi-rette.jpg"],
  ["/pannelli-xlam", "nav.pannelli-xlam", "Pannelli X-LAM", "/img/emma/p-xlam-strati.jpg"],
  ["/#casa-in-legno", "nav.casa-in-legno", "La casa in legno", "/img/emma/prj-misto-piscina.jpg"],
  ["/stabilimenti-balneari", "nav.balneari", "Balneari", "/img/emma/balneare-0.jpg"],
  ["/lettiere-animali", "nav.lettiere-animali", "Lettiere per animali", "/img/emma/p-trucioli-lettiere.jpg"],
  ["/biomassa", "nav.biomassa", "Biomassa", "/img/emma/p-bricchetti-studio.jpg"],
];

export const RelatedProducts = () => {
  const t = useT();
  const { pathname } = useLocation();
  const items = FEATURED.filter(([to]) => to !== pathname).slice(0, 4);
  return (
    <section className="bg-[#F7F5F0] px-5 py-20 text-[#121110] sm:px-8 lg:py-24" data-testid="related-products">
      <div className="mx-auto max-w-[1500px]">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#6E685E]">{t("rel.kicker", "Prodotti in evidenza")}</p>
        <h2 className="mt-4 font-display text-3xl font-bold tracking-tight sm:text-4xl">{t("rel.h", "Scopri le altre soluzioni Emma Industrie.")}</h2>
        <ul className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {items.map(([to, k, l, img]) => (
            <li key={to}>
              <Link to={to} className="group block" data-testid={`related-${to.replace(/[^a-z-]/g, "") || "home"}`}>
                <span className="block aspect-[4/3] overflow-hidden bg-[#1E1C1A]">
                  <Pic src={img} alt={t(k, l)} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </span>
                <span className="mt-4 flex items-center justify-between gap-3 border-t border-[#121110]/15 pt-3">
                  <span className="font-display text-xl font-semibold tracking-tight">{t(k, l)}</span>
                  <ArrowUpRight className="h-5 w-5 shrink-0 text-[#C26D38] transition-transform duration-300 group-hover:rotate-45" />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
